import { render, staticRenderFns } from "./unverified.vue?vue&type=template&id=6320f83f&scoped=true&"
import script from "./unverified.vue?vue&type=script&lang=js&"
export * from "./unverified.vue?vue&type=script&lang=js&"
import style0 from "./unverified.vue?vue&type=style&index=0&id=6320f83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320f83f",
  null
  
)

export default component.exports